import { mapGetters } from 'vuex'

export default {
  created () {
    this._fetch()
  },
  watch: {
    '$route' (to, from) {
      this._fetch()
    },
    selected() {
      this.fetchers.filter(fetcher => fetcher.portalContextDependent !== false)
        .forEach(fetcher => {
          this._fetchData(fetcher)
        })
    }
  },
  computed: {
    ...mapGetters('groupSelector', ['selected'])
  },
  methods: {
    _fetch () {
      try {
        let fetchers = this.fetchers || []
        fetchers.forEach(fetcher => {
          this._fetchData(fetcher)
        })
      } catch (error) {
        // nothing
      }
    },
    _fetchData (fetcher) {
      // Add `shouldFetch: someCondition` to fetcher for optional fetching
      if (fetcher.shouldFetch !== false) {
        if (fetcher.namespace) { this.$store.dispatch(`${fetcher.namespace}/${fetcher.action}`, fetcher.options, fetcher.config) } else { this.$store.dispatch(fetcher.action, fetcher.options, fetcher.config) }
      }
    }
  }
}
